import React, { useState, useEffect } from 'react';
import { FaSave, FaSync, FaPlus, FaTrash, FaEdit, FaToggleOn, FaToggleOff, FaTimes, FaUpload, FaFile, FaCheck, FaExclamationTriangle } from 'react-icons/fa';

function ConfiguracaoTributaria() {
  const [providers, setProviders] = useState([]);
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editandoProvider, setEditandoProvider] = useState(null);
  const [mostrarFormRegra, setMostrarFormRegra] = useState(false);
  const [editandoRegra, setEditandoRegra] = useState(null);
  const [certificadoNome, setCertificadoNome] = useState('');
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    tipo: 'GERAL',
    base_url: '',
    api_key: '',
    client_id: '',
    client_secret: '',
    sandbox: true,
    // NOVOS CAMPOS PARA CERTIFICADO DIGITAL
    cnpj_empresa: '',
    certificado_base64: '',
    senha_certificado: '',
    ambiente: 'HOMOLOGACAO',
    certificado_validade: ''
  });
  const [formRegra, setFormRegra] = useState({
    ncm: '',
    uf_origem: 'SP',
    uf_destino: 'SP',
    aliquota_icms: '',
    aliquota_iss: '',
    aliquota_ipi: '',
    aliquota_pis: '',
    aliquota_cofins: '',
    descricao: '',
    tipo: 'ESTADUAL',
    data_inicio: new Date().toISOString().split('T')[0],
    data_fim: '',
    provider_id: ''
  });

  const token = localStorage.getItem('token');

  const fetchProviders = async () => {
    setLoading(true);
    try {
      const response = await fetch('/tax/providers', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar provedores');
      const data = await response.json();
      setProviders(data.providers || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchRules = async () => {
    try {
      const response = await fetch('/tax/rules', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar regras');
      const data = await response.json();
      setRules(data.rules || []);
    } catch (err) {
      console.error('Erro ao buscar regras:', err);
    }
  };

  useEffect(() => {
    fetchProviders();
    fetchRules();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleRegraChange = (e) => {
    const { name, value } = e.target;
    setFormRegra({
      ...formRegra,
      [name]: value
    });
  };

  // ============================================
  // UPLOAD DO CERTIFICADO DIGITAL
  // ============================================
  const handleCertificadoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    // Validar extensão do arquivo
    const ext = file.name.split('.').pop().toLowerCase();
    if (!['pfx', 'p12'].includes(ext)) {
      setError('❌ O certificado deve ser um arquivo .pfx ou .p12');
      return;
    }

    // Validar tamanho (máximo 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setError('❌ O certificado não pode ter mais que 5MB');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      // Remove o prefixo "data:application/...;base64,"
      const base64 = event.target.result.split(',')[1];
      setFormData({
        ...formData,
        certificado_base64: base64
      });
      setCertificadoNome(file.name);
      setSuccess('✅ Certificado carregado com sucesso!');
      setTimeout(() => setSuccess(''), 3001);
    };
    reader.onerror = () => {
      setError('❌ Erro ao ler o arquivo do certificado');
    };
    reader.readAsDataURL(file);
  };

  // ============================================
  // REMOVER CERTIFICADO
  // ============================================
  const handleRemoverCertificado = () => {
    setFormData({
      ...formData,
      certificado_base64: ''
    });
    setCertificadoNome('');
    document.getElementById('certificadoInput').value = '';
  };

  const handleSubmitProvider = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Validar campos obrigatórios para provedor FEDERAL
    if (formData.tipo === 'FEDERAL') {
      if (!formData.cnpj_empresa) {
        setError('❌ CNPJ da empresa é obrigatório para provedor FEDERAL');
        setLoading(false);
        return;
      }
      if (!formData.certificado_base64) {
        setError('❌ Certificado digital é obrigatório para provedor FEDERAL');
        setLoading(false);
        return;
      }
      if (!formData.senha_certificado) {
        setError('❌ Senha do certificado é obrigatória para provedor FEDERAL');
        setLoading(false);
        return;
      }
    }

    try {
      const url = editandoProvider 
        ? `/tax/providers/${editandoProvider.id}`
        : '/tax/providers';
      
      const method = editandoProvider ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || (editandoProvider ? 'Erro ao atualizar' : 'Erro ao criar'));
      }

      setSuccess(editandoProvider ? '✅ Provedor atualizado!' : '✅ Provedor criado!');
      setMostrarForm(false);
      setEditandoProvider(null);
      setCertificadoNome('');
      setFormData({
        nome: '',
        descricao: '',
        tipo: 'GERAL',
        base_url: '',
        api_key: '',
        client_id: '',
        client_secret: '',
        sandbox: true,
        cnpj_empresa: '',
        certificado_base64: '',
        senha_certificado: '',
        ambiente: 'HOMOLOGACAO',
        certificado_validade: ''
      });
      fetchProviders();
      setTimeout(() => setSuccess(''), 3001);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitRegra = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const url = editandoRegra 
        ? `/tax/rules/${editandoRegra.id}`
        : '/tax/rules';
      
      const method = editandoRegra ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formRegra)
      });

      if (!response.ok) throw new Error(editandoRegra ? 'Erro ao atualizar' : 'Erro ao criar');

      setSuccess(editandoRegra ? '✅ Regra atualizada!' : '✅ Regra criada!');
      setMostrarFormRegra(false);
      setEditandoRegra(null);
      setFormRegra({
        ncm: '',
        uf_origem: 'SP',
        uf_destino: 'SP',
        aliquota_icms: '',
        aliquota_iss: '',
        aliquota_ipi: '',
        aliquota_pis: '',
        aliquota_cofins: '',
        descricao: '',
        tipo: 'ESTADUAL',
        data_inicio: new Date().toISOString().split('T')[0],
        data_fim: '',
        provider_id: ''
      });
      fetchRules();
      setTimeout(() => setSuccess(''), 3001);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditProvider = (provider) => {
    setEditandoProvider(provider);
    setFormData({
      nome: provider.nome,
      descricao: provider.descricao || '',
      tipo: provider.tipo,
      base_url: provider.base_url,
      api_key: provider.api_key || '',
      client_id: provider.client_id || '',
      client_secret: provider.client_secret || '',
      sandbox: provider.sandbox,
      cnpj_empresa: provider.cnpj_empresa || '',
      certificado_base64: provider.certificado_base64 || '',
      senha_certificado: provider.senha_certificado || '',
      ambiente: provider.ambiente || 'HOMOLOGACAO',
      certificado_validade: provider.certificado_validade || ''
    });
    if (provider.certificado_base64) {
      setCertificadoNome('✅ Certificado carregado');
    }
    setMostrarForm(true);
  };

  const handleEditRegra = (regra) => {
    setEditandoRegra(regra);
    setFormRegra({
      ncm: regra.ncm || '',
      uf_origem: regra.uf_origem || 'SP',
      uf_destino: regra.uf_destino || 'SP',
      aliquota_icms: regra.aliquota_icms || '',
      aliquota_iss: regra.aliquota_iss || '',
      aliquota_ipi: regra.aliquota_ipi || '',
      aliquota_pis: regra.aliquota_pis || '',
      aliquota_cofins: regra.aliquota_cofins || '',
      descricao: regra.descricao || '',
      tipo: regra.tipo || 'ESTADUAL',
      data_inicio: regra.data_inicio ? regra.data_inicio.split('T')[0] : new Date().toISOString().split('T')[0],
      data_fim: regra.data_fim ? regra.data_fim.split('T')[0] : '',
      provider_id: regra.provider_id || ''
    });
    setMostrarFormRegra(true);
  };

  const handleToggleProvider = async (id, ativo) => {
    try {
      const response = await fetch(`/tax/providers/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ ativo: !ativo })
      });
      if (!response.ok) throw new Error('Erro ao atualizar');
      fetchProviders();
      alert(`Provedor ${!ativo ? 'ativado' : 'desativado'} com sucesso!`);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleSincronizar = async () => {
    if (!window.confirm('Sincronizar regras tributárias com as APIs?')) return;
    setLoading(true);
    try {
      const response = await fetch('/tax/sync', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao sincronizar');
      const data = await response.json();
      setSuccess(`✅ ${data.message}`);
      fetchRules();
      setTimeout(() => setSuccess(''), 3001);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSincronizarHybrid = async () => {
    if (!window.confirm('Sincronizar regras tributárias com as APIs (híbrido)?\n\nIsso vai buscar dados do IBPT, SEFAZ e Receita Federal.')) return;
    
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await fetch('/tax/sync-hybrid', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao sincronizar');
      
      const data = await response.json();
      setSuccess(`✅ Sincronização híbrida concluída! ${data.total || 0} regras atualizadas.`);
      fetchRules();
      setTimeout(() => setSuccess(''), 5000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  // Styles responsivos
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '20px',
      flexWrap: 'wrap',
      gap: '10px'
    },
    headerTitle: {
      flex: '1',
      minWidth: '200px'
    },
    headerButtons: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      alignItems: 'center'
    },
    button: {
      padding: '8px 16px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '14px',
      whiteSpace: 'nowrap'
    },
    buttonPrimary: {
      backgroundColor: '#007bff',
      color: 'white'
    },
    buttonSuccess: {
      backgroundColor: '#28a745',
      color: 'white'
    },
    buttonInfo: {
      backgroundColor: '#17a2b8',
      color: 'white'
    },
    buttonPurple: {
      backgroundColor: '#6f42c1',
      color: 'white'
    },
    buttonDanger: {
      backgroundColor: '#dc3545',
      color: 'white'
    },
    buttonWarning: {
      backgroundColor: '#ffc107',
      color: '#212529'
    },
    form: {
      backgroundColor: '#f8f9fa',
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '20px',
      border: '1px solid #dee2e6'
    },
    formGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px'
    },
    formFullWidth: {
      gridColumn: '1 / -1'
    },
    card: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      marginBottom: '20px',
      overflowX: 'auto'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '14px'
    },
    tableHead: {
      backgroundColor: '#f8f9fa'
    },
    tableCell: {
      padding: '10px',
      textAlign: 'left',
      borderBottom: '1px solid #dee2e6'
    },
    statusBadge: {
      padding: '3px 10px',
      borderRadius: '12px',
      display: 'inline-block',
      fontSize: '12px'
    },
    statusActive: {
      backgroundColor: '#d4edda',
      color: '#155724'
    },
    statusInactive: {
      backgroundColor: '#f8d7da',
      color: '#721c24'
    },
    statusWarning: {
      backgroundColor: '#fff3cd',
      color: '#856404'
    },
    alert: {
      padding: '10px',
      borderRadius: '4px',
      marginBottom: '15px'
    },
    alertError: {
      backgroundColor: '#ffebee',
      color: '#c62828',
      border: '1px solid #ffcdd2'
    },
    alertSuccess: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      border: '1px solid #c8e6c9'
    },
    alertWarning: {
      backgroundColor: '#fff3cd',
      color: '#856404',
      border: '1px solid #ffc107'
    },
    loading: {
      textAlign: 'center',
      padding: '50px',
      fontSize: '18px'
    },
    uploadArea: {
      border: '2px dashed #007bff',
      borderRadius: '8px',
      padding: '20px',
      textAlign: 'center',
      cursor: 'pointer',
      backgroundColor: '#f8f9fa',
      transition: 'all 0.3s'
    },
    certificadoInfo: {
      backgroundColor: '#e8f5e9',
      padding: '10px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginTop: '10px'
    },
    required: {
      color: '#dc3545',
      marginLeft: '4px'
    }
  };

  // Media queries
  const responsiveStyles = `
    @media (max-width: 768px) {
      .container { padding: 10px; }
      .form-grid { grid-template-columns: 1fr !important; }
      .header { flex-direction: column; align-items: stretch !important; }
      .header-buttons { 
        display: flex; 
        flex-wrap: wrap; 
        gap: 5px; 
        width: 100%;
      }
      .header-buttons button { 
        flex: 1; 
        min-width: calc(50% - 5px);
        justify-content: center;
        font-size: 12px;
        padding: 8px 12px;
      }
      .table-container { overflow-x: auto; }
      .table { font-size: 12px; }
      .table th, .table td { padding: 6px 8px; }
      .hide-mobile { display: none; }
      .card { padding: 12px; }
      .form { padding: 12px; }
    }
    @media (max-width: 480px) {
      .header-buttons button { 
        min-width: 100%;
        font-size: 11px;
        padding: 6px 10px;
      }
      .table { font-size: 11px; }
      .table th, .table td { padding: 4px 6px; }
      .status-badge { font-size: 10px; padding: 2px 6px; }
      h2 { font-size: 18px; }
      h3 { font-size: 16px; }
    }
  `;

  if (loading) {
    return <div style={styles.loading}>🔄 Carregando...</div>;
  }

  return (
    <>
      <style>{responsiveStyles}</style>
      <div className="container" style={styles.container}>
        <div className="header" style={styles.header}>
          <div style={styles.headerTitle}>
            <h2 style={{ margin: 0 }}>📊 Configuração Tributária</h2>
            <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: '14px' }}>
              👑 Apenas Super Administradores podem configurar regras tributárias
            </p>
          </div>
          <div className="header-buttons" style={styles.headerButtons}>
            <button 
              onClick={handleSincronizar} 
              style={{ ...styles.button, ...styles.buttonInfo }}
            >
              <FaSync /> Sincronizar
            </button>
            <button 
              onClick={handleSincronizarHybrid} 
              style={{ ...styles.button, ...styles.buttonPurple }}
            >
              <FaSync /> Híbrido
            </button>
            <button 
              onClick={() => { setMostrarForm(!mostrarForm); setEditandoProvider(null); setCertificadoNome(''); }} 
              style={{ ...styles.button, ...styles.buttonSuccess }}
            >
              <FaPlus /> Provedor
            </button>
            <button 
              onClick={() => { setMostrarFormRegra(!mostrarFormRegra); setEditandoRegra(null); }} 
              style={{ ...styles.button, ...styles.buttonPrimary }}
            >
              <FaPlus /> Regra
            </button>
          </div>
        </div>

        {error && (
          <div style={{ ...styles.alert, ...styles.alertError }}>
            ❌ {error}
          </div>
        )}
        {success && (
          <div style={{ ...styles.alert, ...styles.alertSuccess }}>
            ✅ {success}
          </div>
        )}

        {/* ============================================
            FORM PROVEDOR (COM CERTIFICADO)
        ============================================ */}
        {mostrarForm && (
          <form onSubmit={handleSubmitProvider} className="form" style={styles.form}>
            <h3>{editandoProvider ? '✏️ Editar Provedor' : '📝 Novo Provedor Tributário'}</h3>
            
            <div className="form-grid" style={styles.formGrid}>
              {/* Campos básicos */}
              <div>
                <label>Nome *</label>
                <input 
                  name="nome" 
                  value={formData.nome} 
                  onChange={handleChange} 
                  required 
                  placeholder="Ex: Focus NFe, SEFAZ" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Tipo *</label>
                <select 
                  name="tipo" 
                  value={formData.tipo} 
                  onChange={handleChange} 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }}
                >
                  <option value="GERAL">Geral</option>
                  <option value="FEDERAL">Federal (NF-e)</option>
                  <option value="ESTADUAL">Estadual</option>
                  <option value="MUNICIPAL">Municipal (NFS-e)</option>
                </select>
              </div>
              <div>
                <label>Base URL *</label>
                <input 
                  name="base_url" 
                  value={formData.base_url} 
                  onChange={handleChange} 
                  required 
                  placeholder="https://api.focusnfe.com.br/v2" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>API Key</label>
                <input 
                  name="api_key" 
                  value={formData.api_key} 
                  onChange={handleChange} 
                  type="password" 
                  placeholder="Chave da API" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Client ID</label>
                <input 
                  name="client_id" 
                  value={formData.client_id} 
                  onChange={handleChange} 
                  placeholder="Client ID" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Client Secret</label>
                <input 
                  name="client_secret" 
                  value={formData.client_secret} 
                  onChange={handleChange} 
                  type="password" 
                  placeholder="Client Secret" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Descrição</label>
                <input 
                  name="descricao" 
                  value={formData.descricao} 
                  onChange={handleChange} 
                  placeholder="Descrição do provedor" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '25px' }}>
                <label>Modo Sandbox</label>
                <input 
                  name="sandbox" 
                  checked={formData.sandbox} 
                  onChange={handleChange} 
                  type="checkbox" 
                  style={{ width: '20px', height: '20px' }} 
                />
              </div>

              {/* ============================================
                  CAMPOS PARA CERTIFICADO DIGITAL (FEDERAL)
              ============================================ */}
              {formData.tipo === 'FEDERAL' && (
                <>
                  <div style={{ ...styles.formFullWidth, borderTop: '2px solid #007bff', paddingTop: '15px', marginTop: '5px' }}>
                    <h4 style={{ color: '#007bff', margin: '0 0 10px 0' }}>
                      🔐 Certificado Digital (Obrigatório para NF-e)
                    </h4>
                  </div>

                  <div>
                    <label>CNPJ da Empresa <span style={styles.required}>*</span></label>
                    <input 
                      name="cnpj_empresa" 
                      value={formData.cnpj_empresa} 
                      onChange={handleChange}
                      required
                      placeholder="00.000.000/0000-00"
                      style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                    />
                  </div>

                  <div>
                    <label>Ambiente <span style={styles.required}>*</span></label>
                    <select 
                      name="ambiente" 
                      value={formData.ambiente} 
                      onChange={handleChange}
                      style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }}
                    >
                      <option value="HOMOLOGACAO">🧪 Homologação (Testes)</option>
                      <option value="PRODUCAO">🚀 Produção (Real)</option>
                    </select>
                    {formData.ambiente === 'HOMOLOGACAO' && (
                      <small style={{ color: '#856404', display: 'block', marginTop: '4px' }}>
                        ⚠️ Em homologação, as notas não têm validade fiscal
                      </small>
                    )}
                  </div>

                  <div style={styles.formFullWidth}>
                    <label>Upload do Certificado (.pfx ou .p12) <span style={styles.required}>*</span></label>
                    <div 
                      style={styles.uploadArea}
                      onClick={() => document.getElementById('certificadoInput').click()}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        if (file) {
                          const input = document.getElementById('certificadoInput');
                          const dt = new DataTransfer();
                          dt.items.add(file);
                          input.files = dt.files;
                          handleCertificadoUpload({ target: input });
                        }
                      }}
                    >
                      {!formData.certificado_base64 ? (
                        <>
                          <FaUpload size={32} style={{ color: '#007bff', marginBottom: '10px' }} />
                          <p style={{ margin: '5px 0', fontSize: '14px' }}>
                            <strong>Clique ou arraste o arquivo do certificado</strong>
                          </p>
                          <p style={{ margin: '5px 0', fontSize: '12px', color: '#6c757d' }}>
                            Formatos aceitos: .pfx, .p12 (máx. 5MB)
                          </p>
                          <input 
                            id="certificadoInput"
                            type="file" 
                            accept=".pfx,.p12" 
                            onChange={handleCertificadoUpload}
                            style={{ display: 'none' }} 
                          />
                        </>
                      ) : (
                        <div style={styles.certificadoInfo}>
                          <FaCheck size={20} color="#28a745" />
                          <div style={{ textAlign: 'left' }}>
                            <strong style={{ color: '#155724' }}>✅ Certificado carregado</strong>
                            <p style={{ margin: '2px 0', fontSize: '12px', color: '#6c757d' }}>
                              {certificadoNome || 'Certificado digital'}
                            </p>
                          </div>
                          <button 
                            type="button"
                            onClick={handleRemoverCertificado}
                            style={{ 
                              marginLeft: 'auto',
                              background: '#dc3545',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '4px 12px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            Remover
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label>Senha do Certificado <span style={styles.required}>*</span></label>
                    <input 
                      name="senha_certificado" 
                      value={formData.senha_certificado} 
                      onChange={handleChange}
                      type="password"
                      required
                      placeholder="Senha do certificado"
                      style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                    />
                    <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                      🔒 A senha é armazenada de forma criptografada
                    </small>
                  </div>
                </>
              )}

              {/* Aviso para outros tipos */}
              {formData.tipo !== 'FEDERAL' && (
                <div style={{ ...styles.alert, ...styles.alertWarning, ...styles.formFullWidth, marginTop: '10px' }}>
                  <FaExclamationTriangle /> Este provedor não requer certificado digital. 
                  Para emitir NF-e, selecione o tipo "Federal".
                </div>
              )}
            </div>

            <button 
              type="submit" 
              disabled={loading} 
              style={{ ...styles.button, ...styles.buttonPrimary, marginTop: '15px' }}
            >
              <FaSave /> {editandoProvider ? 'Atualizar Provedor' : 'Salvar Provedor'}
            </button>
          </form>
        )}

        {/* Form Regra (mantido igual) */}
        {mostrarFormRegra && (
          <form onSubmit={handleSubmitRegra} className="form" style={styles.form}>
            <h3>{editandoRegra ? '✏️ Editar Regra' : '📝 Nova Regra Tributária'}</h3>
            <div className="form-grid" style={styles.formGrid}>
              <div>
                <label>NCM *</label>
                <input 
                  name="ncm" 
                  value={formRegra.ncm} 
                  onChange={handleRegraChange} 
                  required 
                  placeholder="Ex: 8471.50.10" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>UF Origem</label>
                <input 
                  name="uf_origem" 
                  value={formRegra.uf_origem} 
                  onChange={handleRegraChange} 
                  placeholder="SP" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>UF Destino</label>
                <input 
                  name="uf_destino" 
                  value={formRegra.uf_destino} 
                  onChange={handleRegraChange} 
                  placeholder="RJ" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Alíquota ICMS (%)</label>
                <input 
                  name="aliquota_icms" 
                  value={formRegra.aliquota_icms} 
                  onChange={handleRegraChange} 
                  type="number" 
                  step="0.01" 
                  placeholder="18.00" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Alíquota ISS (%)</label>
                <input 
                  name="aliquota_iss" 
                  value={formRegra.aliquota_iss} 
                  onChange={handleRegraChange} 
                  type="number" 
                  step="0.01" 
                  placeholder="5.00" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Alíquota IPI (%)</label>
                <input 
                  name="aliquota_ipi" 
                  value={formRegra.aliquota_ipi} 
                  onChange={handleRegraChange} 
                  type="number" 
                  step="0.01" 
                  placeholder="0.00" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Alíquota PIS (%)</label>
                <input 
                  name="aliquota_pis" 
                  value={formRegra.aliquota_pis} 
                  onChange={handleRegraChange} 
                  type="number" 
                  step="0.01" 
                  placeholder="1.65" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Alíquota COFINS (%)</label>
                <input 
                  name="aliquota_cofins" 
                  value={formRegra.aliquota_cofins} 
                  onChange={handleRegraChange} 
                  type="number" 
                  step="0.01" 
                  placeholder="7.60" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Tipo</label>
                <select 
                  name="tipo" 
                  value={formRegra.tipo} 
                  onChange={handleRegraChange} 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }}
                >
                  <option value="FEDERAL">Federal</option>
                  <option value="ESTADUAL">Estadual</option>
                  <option value="MUNICIPAL">Municipal</option>
                </select>
              </div>
              <div>
                <label>Provedor</label>
                <select 
                  name="provider_id" 
                  value={formRegra.provider_id} 
                  onChange={handleRegraChange} 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }}
                >
                  <option value="">Selecione...</option>
                  {providers.filter(p => p.ativo).map(p => (
                    <option key={p.id} value={p.id}>{p.nome}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Data Início</label>
                <input 
                  name="data_inicio" 
                  value={formRegra.data_inicio} 
                  onChange={handleRegraChange} 
                  type="date" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div>
                <label>Data Fim</label>
                <input 
                  name="data_fim" 
                  value={formRegra.data_fim} 
                  onChange={handleRegraChange} 
                  type="date" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label>Descrição *</label>
                <input 
                  name="descricao" 
                  value={formRegra.descricao} 
                  onChange={handleRegraChange} 
                  required 
                  placeholder="Descrição da regra" 
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }} 
                />
              </div>
            </div>
            <button 
              type="submit" 
              disabled={loading} 
              style={{ ...styles.button, ...styles.buttonPrimary, marginTop: '15px' }}
            >
              <FaSave /> {editandoRegra ? 'Atualizar Regra' : 'Salvar Regra'}
            </button>
          </form>
        )}

        {/* Provedores */}
        <div className="card" style={styles.card}>
          <h3>📋 Provedores Configurados</h3>
          <div className="table-container">
            <table className="table" style={styles.table}>
              <thead>
                <tr style={styles.tableHead}>
                  <th style={styles.tableCell}>Nome</th>
                  <th style={styles.tableCell}>Tipo</th>
                  <th className="hide-mobile" style={styles.tableCell}>Base URL</th>
                  <th style={{ ...styles.tableCell, textAlign: 'center' }}>Sandbox</th>
                  <th style={{ ...styles.tableCell, textAlign: 'center' }}>Status</th>
                  <th style={{ ...styles.tableCell, textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {providers.length === 0 ? (
                  <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>📭 Nenhum provedor configurado</td></tr>
                ) : (
                  providers.map(provider => (
                    <tr key={provider.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                      <td style={styles.tableCell}>
                        {provider.nome}
                        {provider.tipo === 'FEDERAL' && provider.certificado_base64 && (
                          <span style={{ color: '#28a745', fontSize: '11px', display: 'block' }}>
                            🔐 Certificado OK
                          </span>
                        )}
                        {provider.tipo === 'FEDERAL' && !provider.certificado_base64 && (
                          <span style={{ color: '#dc3545', fontSize: '11px', display: 'block' }}>
                            ❌ Sem certificado
                          </span>
                        )}
                      </td>
                      <td style={styles.tableCell}>
                        {provider.tipo}
                        {provider.tipo === 'FEDERAL' && (
                          <span style={{ fontSize: '11px', display: 'block', color: '#6c757d' }}>
                            {provider.ambiente || 'HOMOLOGACAO'}
                          </span>
                        )}
                      </td>
                      <td className="hide-mobile" style={styles.tableCell}>{provider.base_url}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'center' }}>{provider.sandbox ? '✅' : '❌'}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                        <span className="status-badge" style={{ ...styles.statusBadge, ...(provider.ativo ? styles.statusActive : styles.statusInactive) }}>
                          {provider.ativo ? '✅ Ativo' : '❌ Inativo'}
                        </span>
                      </td>
                      <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                        <button onClick={() => handleEditProvider(provider)} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', marginRight: '10px' }} title="Editar">
                          <FaEdit />
                        </button>
                        <button onClick={() => handleToggleProvider(provider.id, provider.ativo)} style={{ background: 'none', border: 'none', color: provider.ativo ? '#dc3545' : '#28a745', cursor: 'pointer' }} title={provider.ativo ? 'Desativar' : 'Ativar'}>
                          {provider.ativo ? <FaToggleOff size={20} /> : <FaToggleOn size={20} />}
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Regras */}
        <div className="card" style={styles.card}>
          <h3>📋 Regras Tributárias</h3>
          <div className="table-container">
            <table className="table" style={styles.table}>
              <thead>
                <tr style={styles.tableHead}>
                  <th style={styles.tableCell}>NCM</th>
                  <th style={styles.tableCell}>UF Origem</th>
                  <th style={{ ...styles.tableCell, textAlign: 'right' }}>ICMS</th>
                  <th style={{ ...styles.tableCell, textAlign: 'right' }}>PIS</th>
                  <th style={{ ...styles.tableCell, textAlign: 'right' }}>COFINS</th>
                  <th className="hide-mobile" style={{ ...styles.tableCell, textAlign: 'center' }}>Vigência</th>
                  <th style={{ ...styles.tableCell, textAlign: 'center' }}>Status</th>
                  <th style={{ ...styles.tableCell, textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {rules.length === 0 ? (
                  <tr><td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>📭 Nenhuma regra cadastrada. Clique em "Nova Regra" para criar.</td></tr>
                ) : (
                  rules.map(rule => (
                    <tr key={rule.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                      <td style={styles.tableCell}>{rule.ncm || '-'}</td>
                      <td style={styles.tableCell}>{rule.uf_origem || '-'}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'right' }}>{rule.aliquota_icms ? `${rule.aliquota_icms}%` : '-'}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'right' }}>{rule.aliquota_pis ? `${rule.aliquota_pis}%` : '-'}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'right' }}>{rule.aliquota_cofins ? `${rule.aliquota_cofins}%` : '-'}</td>
                      <td className="hide-mobile" style={{ ...styles.tableCell, textAlign: 'center' }}>{formatDate(rule.data_inicio)}</td>
                      <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                        <span className="status-badge" style={{ ...styles.statusBadge, ...(rule.ativo ? styles.statusActive : styles.statusInactive) }}>
                          {rule.ativo ? '✅ Ativo' : '❌ Inativo'}
                        </span>
                      </td>
                      <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                        <button onClick={() => handleEditRegra(rule)} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', marginRight: '10px' }} title="Editar">
                          <FaEdit />
                        </button>
                        <button style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }} title="Excluir">
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfiguracaoTributaria;